<mat-form-field appearance="outline" class="full-width">
  <mat-label>{{ placeholder }}</mat-label>
  <input
    matInput
    [formControl]="formControl"
    [matAutocomplete]="auto"
    (blur)="handleBlur()"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    [class]="panelClass"
    (optionSelected)="onOptionSelected($event.option.value)"
    [displayWith]="displayFn"
  >
    <mat-option class="ulaap-contact-autocomplete-option" *ngFor="let opt of options$ | async" [value]="opt">
      <span class="ulaap-contact-autocomplete-label">{{ opt.label }}</span>
      <span class="ulaap-contact-autocomplete-uuid">{{ contactUuid(opt) }}</span>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>